import { useState, useEffect } from 'react'
import { LiffUser, ProductLineItemType, LineItemModifierType } from 'services/hooks/dine-in/useGetGlobalCart'
import {} from 'enums/index'
import { LineItemInvalidEnum, DineInLineItemStatusEnumStr } from 'enums'
import { LineItemServiceEnum } from 'graphQL/dinein/generate/operations'

export interface LineItem {
  createdByUser: LiffUser
  lineItemBatchID: number
  createdAt: string
}

export interface OrderLineItemType {
  id: number
  lineItemBatchID: number
  productID: number
  totalSatangs: number
  customNotes: string
  quantity: number
  product: ProductLineItemType
  status: DineInLineItemStatusEnumStr
  invalids: LineItemInvalidEnum[]
  modifiers: LineItemModifierType[]
  createdByUser: LiffUser
  createdAt: string
  buffetPackageID?: number
  serviceType?: keyof typeof LineItemServiceEnum
}

interface useGlobalCartProps {
  globalCart: {
    lineItems: OrderLineItemType[]
  }
}

export interface GlobalCart {
  lineItemBatchID: number
  createdAt: string
  liffUser: LiffUser
  lineItems: OrderLineItemType[]
  buffetPackageID?: number
  serviceType?: keyof typeof LineItemServiceEnum
}

const useGlobalCart = ({ globalCart }: useGlobalCartProps) => {
  const [globalCarts, setGlobalCarts] = useState<GlobalCart[]>([])

  useEffect(() => {
    const newGlobalCarts: GlobalCart[] = []
    globalCart.lineItems?.forEach((lineItem) => {
      const indexCurrentUser = newGlobalCarts.findIndex(({ liffUser, lineItemBatchID, serviceType }) => {
        return (
          liffUser?.id === lineItem.createdByUser.id &&
          lineItemBatchID === lineItem.lineItemBatchID &&
          serviceType === lineItem.serviceType
        )
      })
      const foundUser = indexCurrentUser !== -1
      if (foundUser) {
        newGlobalCarts[indexCurrentUser].lineItems.push(lineItem)
      } else {
        newGlobalCarts.push({
          lineItemBatchID: lineItem.lineItemBatchID,
          createdAt: lineItem.createdAt,
          liffUser: lineItem.createdByUser,
          lineItems: [lineItem],
          buffetPackageID: lineItem?.buffetPackageID ? lineItem.buffetPackageID : 0,
          serviceType: lineItem.serviceType,
        })
      }
    })
    setGlobalCarts(newGlobalCarts)
  }, [globalCart.lineItems])

  return { globalCarts }
}

export default useGlobalCart
